import type { TFunction } from "i18next";

/** Fields the clipboard dump reads. The card DTO and the public share payload both fit. */
type BriefCopyInput = {
  videoName: string;
  duration: string;
  notes?: string | null;
  hooks: ReadonlyArray<{ hookIndex: number; direction: string; line: string }>;
  concept: { direction: string; line: string };
  cta: { direction: string; line: string };
};

/** Public preview URL — token is the brief's own id, same as persona scripts. */
export function buildPersonaBriefShareUrl(briefId: string, origin: string): string {
  return `${origin}/s/${briefId}`;
}

/** Plain-text brief dump for clipboard — direction and on-camera lines. */
export function formatPersonaBriefForCopy(brief: BriefCopyInput, t: TFunction): string {
  const directionLabel = t("personaOpportunities.scripts.briefs.copyDirection", "Direction");
  const lineLabel = t("personaOpportunities.scripts.briefs.copyLine", "Line");
  const lines: string[] = [brief.videoName.trim(), brief.duration.trim(), ""];

  const orderedHooks = [...brief.hooks].sort((a, b) => a.hookIndex - b.hookIndex);
  for (const hook of orderedHooks) {
    lines.push(
      t("personaOpportunities.scripts.briefs.copyHook", {
        defaultValue: "Hook {{index}}",
        index: hook.hookIndex,
      }),
    );
    lines.push(`  ${directionLabel}: ${hook.direction.trim()}`);
    lines.push(`  ${lineLabel}: ${hook.line.trim()}`);
  }
  lines.push("");
  lines.push(t("personaOpportunities.scripts.briefs.conceptTitle", "Concept"));
  lines.push(`  ${directionLabel}: ${brief.concept.direction.trim()}`);
  lines.push(`  ${lineLabel}: ${brief.concept.line.trim()}`);
  lines.push("");
  lines.push(t("personaOpportunities.scripts.briefs.ctaTitle", "Call to action"));
  lines.push(`  ${directionLabel}: ${brief.cta.direction.trim()}`);
  lines.push(`  ${lineLabel}: ${brief.cta.line.trim()}`);

  if (brief.notes?.trim()) {
    lines.push("");
    lines.push(
      `${t("personaOpportunities.scripts.briefs.copyNotes", "Notes")}: ${brief.notes.trim()}`,
    );
  }

  return lines.join("\n").trimEnd();
}
